import { host, dev_host, admin_login_path } from './host_data'
const url = host + admin_login_path

export const TOKEN_KEY = "@admin-Token";

export const auth = async (user, passwd) => {
  console.log('Credenciais recebidas: ', user, passwd)
  if (user === 'fai' && passwd === '022216') {
    return {
      status: 'authenticated',
      message: 'Autenticado com Sucesso'
    }
  } else {
    return {
      status: 'not_authenticated',
      message: 'Credenciais Incorretas'
    }
  }
}

export default function login({setIsAuthenticated}) {
  try {
      fetch(url)
        .then(response => response.json())
        .then(data => {
          localStorage.setItem(TOKEN_KEY, data);
          setIsAuthenticated(true)
          window.location.replace = '/admin'
        })
        .catch(error => {
          console.error('Erro ao obter conteúdo da resposta:', error);
        });
        
  } catch (error) {
    window.alert('Nao Foi Possivel Realizar o Login: ', error)
  }
};

export const logout = () => {
  localStorage.clear()
  window.location.href = '/admin?status={"logout"}'
  console.log('Sessao Encerrada!')
};